import React from 'react';
import { Icon } from 'b3';
import FullEmailModal from '../../FullEmailModal';

import TimelineItem from './TimelineItem';

export default class EmailTimelineItem extends React.Component {
    nameFromEmailAddress(email){
        if (email.indexOf("<") > 0 && email.indexOf(">") > 0){
            return email.split("<")[0].trim();
        }
        return email;
    }

    emailFromEmailAddress(email){
        
        if (email.indexOf("<") > 0 && email.indexOf(">") > 0){
            email = email.split("<")[1].trim();
            email = email.split('>')[0].trim();
        }
        return email;
    }

    userForEmail(email){
        email = this.emailFromEmailAddress(email);
 
        var user = this.props.users && this.props.users.find( user => user.email == email );
        if (user){
            return user;
        }
        return false;
    }

    openEmail(){        
        this.props.openModal(FullEmailModal, { 
            showCancel : false,
            email: this.props, 
            to : this.nameFromEmailAddress(this.props.to),
            from : this.nameFromEmailAddress(this.props.from),
            toEmail : this.emailFromEmailAddress(this.props.to),
            user : this.userForEmail(this.props.from)
        });
    }

    render(){
    	var icon 	= <Icon icon="mail-1" />;
    	var avatar = <img src="/img/avatars/fergie.jpg" className="avatar" />;
        var extraInfo = <p><b>To:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b> <Icon icon="profile-1" filled/>{this.nameFromEmailAddress(this.props.to)} ({this.emailFromEmailAddress(this.props.to)}) <br/><b>From: </b><Icon icon="profile-1" filled/>{this.nameFromEmailAddress(this.props.from)} ({this.emailFromEmailAddress(this.props.from)})</p>;

        return (
            <TimelineItem
            	type="email"
            	typeLabel="Email"
            	avatar={avatar}
            	icon={icon}
                extraInfo={extraInfo}
            >
            	{this.props.snippet}
                <span className="clientTimeline__event__content__body__bubble__more" onClick={this.openEmail.bind(this)}>
                    Show More...
                </span>
            </TimelineItem>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/client-timeline/items/EmailTimelineItem.js